export const CustomProductRoutes = {
    customProductGenerator: '/custom-product-generator',
} as const;
